import { ViewModel,View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { IWarehouse } from "../iWarehouse";
import { WarehouseEditorViewModel, WarehouseInserter, WarehouseUpdater } from "../warehouseEditor/warehouseEditor-viewModel";
import  { WarehouseManipulationView } from "./warehouseManipulation-view"
import { translate } from "src/common/utilities";

export class WarehouseManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return translate("warehouseManipulation-viewModel.warehouseDefinition",{});
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.warehouses = ObservableArray.create<Warehouse>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),30);
        this.refresh()
    }
    GetDefaultView(): View <ViewModel> {
        return new WarehouseManipulationView();
    }
    public getTypeId(): string {
        return "VM-2CDE7190-B039-4388-BF58-C2A9274AB3BA"
    }

    public set warehouses(v: ObservableArray<Warehouse>) { this._warehouses = v; } public get warehouses(): ObservableArray<Warehouse> { return this._warehouses;} private _warehouses: ObservableArray<Warehouse>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;

    async refresh(){
        await this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/InventoryManipulationServices/GetAllWarehouses',{
                FurtherQueryInfo:filteringInformation
            });
            this.warehouses.update(...result.Warehouses.map(q=>{
                let r = new Warehouse(this);
                r.id = q.Id;
                r.name = q.Name;
                r.districtId = q.DistrictId;
                r.districtName = q.DistrictName;
                r.parentName = q.ParentName;
                r.parentId = q.ParentId;
                r.hasParent = (q.ParentId == null ? false : true);
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async addNew() {
        let popup = new WarehouseEditorViewModel(this,new WarehouseInserter(), false);
        let result = await this.showPopup(popup);
        if(result!=null){
            this.refresh();
        }
    }
    async edit(warehouse:Warehouse){
        let popup = new WarehouseEditorViewModel(this,new WarehouseUpdater(), true);
        warehouse.cloneTo(popup);
        let result = await this.showPopup(popup);
        if(result!=null){
            this.refresh();
        }
    }

}

export class Warehouse extends ViewModel implements IWarehouse{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:WarehouseManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set districtId(v: string) { this._districtId = v; } public get districtId(): string { return this._districtId;} private _districtId: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName;} private _districtName: string;
    public set parentId(v: string) { this._parentId = v; } public get parentId(): string { return this._parentId;} private _parentId: string;
    public set parentName(v: string) { this._parentName = v; } public get parentName(): string { return this._parentName;} private _parentName: string;
    public set hasParent(v: boolean) { this._hasParent = v; } public get hasParent(): boolean { return this._hasParent;} private _hasParent: boolean;
    
    
        
    private _typedParent : WarehouseManipulationViewModel;

    cloneTo(warehouse: IWarehouse) {
        warehouse.id = this.id;
        warehouse.name = this.name;
        warehouse.districtId = this.districtId;
        warehouse.districtName = this.districtName;
        warehouse.parentId = this.parentId,
        warehouse.parentName = this.parentName,
        warehouse.hasParent = this.hasParent
    }
    edit(){
        this._typedParent.edit(this);
    }
}